import React, { useEffect, useState } from 'react';
import {
  useApexAdminPortalDispatchContext,
  useApexAdminPortalStateContext,
} from 'Components/AdvisorApp/Viewport/ApexAdminPortal/ApexAdminPortalContext';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import fr from 'facet-rest';
import { displayErrorMessage, displaySuccess } from 'Helpers/FacetNotificationManager';
import { refreshAccountSummaryResource } from 'Components/AdvisorApp/Viewport/ApexAdminPortal/ApexAdminPortalActions';
import View from './View';

const AccountInfo = () => {
  const { accountSummaryResource } = useApexAdminPortalStateContext();
  const { rootNodeProps } = useEventTrackingLogEvent({ nodeName: 'Account Info' });
  const [accountCreationRequest, setAccountCreationRequest] = useState();
  const apexDispatch = useApexAdminPortalDispatchContext();

  const getAccountCreationrRequest = async () => {
    const [acr] = await accountSummaryResource.relationship(fr.relationships.accountCreationRequest.name).link('related').get();
    setAccountCreationRequest(acr);
  };
  const cancelRequest = async () => {
    try {
      await accountCreationRequest?.delete();
      await refreshAccountSummaryResource(accountSummaryResource, apexDispatch, () => {
        displaySuccess('Refreshed Account Request');
      });
      await getAccountCreationrRequest();
      displaySuccess('Request has been cancelled');
    } catch (e) {
      displayErrorMessage(e, 'Failed to cancel request');
    }
  };
  useEffect(() => {
    if (accountSummaryResource) {
      getAccountCreationrRequest();
    }
  }, [accountSummaryResource]);
  return (
    <View
      resource={accountSummaryResource}
      accountCreationRequest={accountCreationRequest}
      amplitudeRootNodeProps={rootNodeProps}
      cancelRequest={cancelRequest}
    />
  );
};

export default AccountInfo;
